import { useMemo } from 'react'
import { ReservationDetailFragment, useReservationDetailQuery } from 'src/api/api.generated'
import { useHotelDate, useTenant } from 'src/app/hooks/context/context.hook'
import { BillF, DepositF, ReservationF } from '../types/reservation-detail.types'
import { getBillsF } from '../utils/bills'
import { getDepositsF } from '../utils/deposits'
import { getReservationF } from '../utils/reservation'

type ReservationDetailFQuery = {
  reservation: ReservationF | undefined | null
  bills: BillF[] | undefined | null
  deposits: DepositF[] | undefined | null
  reservationLink: string | undefined | null
}

export function useReservationDetailFQuery(params: { propertyId: string; reservationId: string }) {
  const tenantId = useTenant().id
  const hotelDate = useHotelDate()
  const q = useReservationDetailQuery({
    variables: { tenantId: tenantId, propertyId: params.propertyId, reservationId: params.reservationId },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  })
  const { data: qData, refetch: refetchReservation, ...qq } = q
  const data: ReservationDetailFQuery | undefined = useMemo(() => {
    if (qData === undefined) {
      return undefined
    }

    let reservation: ReservationDetailFragment | null | undefined

    if (qData.reservations === undefined) {
      reservation = undefined
    } else if (qData.reservations === null || qData.reservations.length <= 0) {
      reservation = null
    } else {
      reservation = qData.reservations[0]
    }

    return {
      reservation: getReservationF(hotelDate, reservation),
      bills: getBillsF(reservation, qData.bills),
      deposits: getDepositsF(reservation, qData.depositDocuments),
      reservationLink: qData.getReservationLink,
    }
  }, [qData, hotelDate])

  return { data, refetchReservation, ...qq }
}
